<template>
  <div class="Imagen">
    <div class="centered">
      <h1>egep</h1>
      <h3>CONSULTORES</h3>
      <p>Consulting Management System</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "slider",
  components: {},
  data: () => ({}),
};
</script>
<style lang="css" scoped>
.Imagen {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../../assets/imagen1.jpg");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  width: 50%;
  position: absolute;
}
.centered {
  color: var(--second-color);
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}
.centered h1 {
  font-size: 140px;
  color: var(--sixth-color);
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 0;
}
.centered h3 {
  position: static;
  font-size: 47px;
  text-align: center;
  color: var(--sixth-color);
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  margin: 0px;
}
.centered p {
  font-size: 1.5rem;
  text-align: center;
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  color: var(--sixth-color);
  width: 80%;
  margin: 10%;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 15%;
  text-align: center;
}
</style>